import { __decorate } from "tslib";
import { ApiResource } from '../../lib/api-decorators';
import { Api } from '../../lib/api.factory';
let ProjectSettingResource = class ProjectSettingResource extends Api {
    async getAll(project) {
        return this.get('/all', { project });
    }
    async update(setting) {
        return this.put('/update', setting);
    }
};
ProjectSettingResource = __decorate([
    ApiResource('/project-setting')
], ProjectSettingResource);
export { ProjectSettingResource };
